import { z } from 'zod';

import { DEFERRED_EVENTS_COOKIE_NAME } from 'src/config/constants';
import { DeferredEventValue } from 'src/types/deferredEvents';
import { readJsonCookie, removeCookie } from 'src/utils/cookies';
import { fireDeferredGtmEvent } from 'src/utils/new-analytics/gtm';

export const processDeferredEventsForSignIn = () => {
  const deferredEvents = readJsonCookie(
    z.array(DeferredEventValue),
    DEFERRED_EVENTS_COOKIE_NAME,
  );
  // Always attempt to remove. This automatically cleans incorrectly formatted
  // cookie values
  removeCookie(DEFERRED_EVENTS_COOKIE_NAME);

  if (deferredEvents === null) {
    return;
  }

  deferredEvents.forEach((event) => {
    fireDeferredGtmEvent(event.name, event.value);
  });
};
